var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotebooklogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2661_112614)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 3.5C5.23833 3.5 3 5.72 3 8.45917V10.8333H3.92167V10.5967C3.92167 9.48583 4.82917 8.585 5.94917 8.585C7.06917 8.585 7.97667 9.48583 7.97667 10.5967V10.8333H8.89833V10.5967C8.89833 8.98083 7.5775 7.67167 5.94917 7.67167C5.315 7.67167 4.7275 7.87 4.24667 8.20833C4.75 7.21583 5.78667 6.535 6.98333 6.535C8.67417 6.535 10.045 7.895 10.045 9.57167V10.8333H10.9667V9.57167C10.9667 7.39 9.18333 5.62083 6.98333 5.62083C5.99417 5.62083 5.08917 5.97833 4.3925 6.57083C5.07667 5.28833 6.435 4.41417 8 4.41417C10.2525 4.41417 12.0783 6.225 12.0783 8.45917V10.8333H13V8.45917C13 5.72 10.7617 3.5 8 3.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2661_112614"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 7.33333,
    fill: "white",
    transform: "translate(3 3.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotebooklogo);
export default __webpack_public_path__ + "static/media/notebooklogo.f610b2225a8eef868ad717e30b9a5d12.svg";
export { ForwardRef as ReactComponent };